import { useContext, useEffect, useRef, useState } from 'react'
import secureLocalStorage from 'react-secure-storage';
import { MyContext } from '../../Context/MyProvider';
import ImageLoad from '../ImageLoad';
import Razorpay from '../../Payment-Getway/Razorpay';
import PageLoading from '../PageLoading';
import Btn_loader from '../Btn_loader';
import AllPayment from '../../Payment-Getway/AllPayment';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import { useTranslation } from 'react-i18next';
const Wallet = () => {

    const { t } = useTranslation();
    const { BaseUrl, HandleCallApi, setIsToast, setToastMsg, paymentRes, setPaymentRes, paymentloading, setPaymentLoading, BookRef, formatPrice } = useContext(MyContext);

    const [loading, setLoading] = useState(true);
    const [paymentList, setPaymentList] = useState([]);
    const [walletamount, setWalletAmount] = useState(0);
    const [pricelist, setPriceList] = useState([]);
    const [selectprice, setSelectPrice] = useState("");
    const [transactionlist, setTransactionList] = useState([]);
    const [isShowPay, setIsShowPay] = useState(false);
    const [texAmount, setTaxAmount] = useState(0);
    const [totalPay, setTotalPay] = useState(0);
    const [selectpayment, setSelectPayment] = useState("");
    const [attributes, setAttributes] = useState("");
    const [istrue, setIsTrue] = useState(false);
    const [apiloading, setApiLoading] = useState("");

    const TransactionRef = useRef(false);
    const PricenRef = useRef(false);
    const PaymentRef = useRef(false);

    const Currency = secureLocalStorage.getItem("currency");
    const Tex = secureLocalStorage.getItem("tex");

    useEffect(() => {
        handleGetTransactionList();
        handleGetPriceList();
        handleGetPaymentList();
    }, []);

    useEffect(() => {
        if (!paymentRes) return;

        if (paymentRes === "PaymentDone") {
            handleAddWallet();
        } else {
            setIsToast(true);
            setToastMsg("Payment faild !!");
            setPaymentRes("");
            setIsTrue(false);
        }
    }, [paymentRes]);

    const handleGetPaymentList = async () => {
        if (PaymentRef.current) return;
        PaymentRef.current = true;
        const id = secureLocalStorage.getItem("Userid");
        const Response = await HandleCallApi("Get", "user/payment_list", { id });
        setPaymentList(Response.data.payment_list);
    }

    const handleGetTransactionList = async () => {
        if (TransactionRef.current) return;
        TransactionRef.current = true;
        const Userid = secureLocalStorage.getItem("Userid");
        if (Userid) {
            const ApiData = {
                id: Userid,
                amount: "",
                offer_amount: "",
                tax_amount: "",
                paymentId: "",
                transactionId: "",
                status: "2",
            }
            const Response = await HandleCallApi("Post", "user/add_wallet", ApiData);
            const { wallet_balance, transaction_list } = Response.data;
            setWalletAmount(wallet_balance);
            setTransactionList(transaction_list);
            setLoading(false);
        }
    }

    const handleGetPriceList = async () => {
        if (PricenRef.current) return;
        PricenRef.current = true;
        const Response = await HandleCallApi("Post", "user/pricing_list", { amount: 0 });
        setPriceList(Response.data.pricing_list);
        setSelectPrice(Response.data.pricing_list[0]);
    }

    const handleAddMoney = () => {
        setIsShowPay(true);
        const TaxCount = (selectprice.price * Tex) / 100;
        setTaxAmount(TaxCount);
        setTotalPay(selectprice.price + TaxCount);
    }

    const handleContinue = () => {
        if (!selectpayment) {
            setIsToast(true);
            setToastMsg("Please select payment method !!");
            return;
        }

        const Userid = secureLocalStorage.getItem("Userid");
        const ApiData = {
            id: Userid,
            amount: selectprice.price,
            offer_amount: selectprice.price,
            tax_amount: texAmount,
            paymentId: selectpayment,
            status: "1"
        }

        secureLocalStorage.setItem("Bookingdata", JSON.stringify(ApiData));
        secureLocalStorage.setItem("Page", "wallet");
        setIsTrue(true);
        setPaymentLoading(true);
    }

    const handleAddWallet = async () => {
        if (BookRef.current) return;
        BookRef.current = true;
        const GetBookingData = secureLocalStorage.getItem("Bookingdata");
        const transactionId = sessionStorage.getItem("transactionid");

        if (GetBookingData && GetBookingData !== "null" && GetBookingData !== "undefined") {
            try {
                const BookingData = typeof GetBookingData === 'string' ? JSON.parse(GetBookingData) : GetBookingData;
                if (BookingData) {
                    setApiLoading("Isbooking");
                    const Response = await HandleCallApi("Post", "user/add_wallet", { ...BookingData, transactionId });
            setIsToast(true);
            setToastMsg(Response.data.message);
            setTransactionList(Response.data.transaction_list);
            setWalletAmount(Response.data.wallet_balance);
            secureLocalStorage.setItem("userwallet", Response.data.wallet_balance);
            setPaymentRes("");
            setIsTrue(false);
            secureLocalStorage.removeItem("Bookingdata");
            sessionStorage.removeItem("transactionid");
            setIsShowPay(false);
            setApiLoading("");
                }
            } catch (e) {
                console.error("Error adding wallet in Wallet.jsx:", e);
                setApiLoading("");
            }
        }
    }

    const handleSelectPayment = (item) => {
        if (paymentloading) return;
        setSelectPayment(item.name);
        setAttributes(item.attribute);
    }

    return (
        <div className='wallet_page'>

            <div className="width_container">

                <div className="section_1 shadow-md">
                    <div className="flex items-center gap-[20px]">
                        <div className="p-[15px] rounded-full bg-orange-200">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" className='w-6 h-6' viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1"></path><path d="M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4"></path></svg>
                        </div>
                        <div className="leading-6">
                            <h1 className='text-[16px] text-gray-600 font-medium'>{t("Total Balance")}</h1>
                            <p className='font-bold text-[25px]'>{formatPrice(walletamount, 2)}</p>
                        </div>
                    </div>
                    <button onClick={handleAddMoney} className='addmoney_button hover:scale-105 hover:shadow-lg'>
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M19.75 12C19.75 12.414 19.414 12.75 19 12.75H12.75V19C12.75 19.414 12.414 19.75 12 19.75C11.586 19.75 11.25 19.414 11.25 19V12.75H5C4.586 12.75 4.25 12.414 4.25 12C4.25 11.586 4.586 11.25 5 11.25H11.25V5C11.25 4.586 11.586 4.25 12 4.25C12.414 4.25 12.75 4.586 12.75 5V11.25H19C19.414 11.25 19.75 11.586 19.75 12Z" fill="currentColor" />
                        </svg>
                        {t("Add Money")}
                    </button>
                </div>

                <div className="section_2">
                    <Swiper
                        slidesPerView={'auto'}
                        spaceBetween={10}
                        modules={[Pagination]}
                        className="mySwiper"
                    >
                        {pricelist.map((item, index) => {
                            const IsSelected = item.id === selectprice.id;
                            return <SwiperSlide key={index} onClick={() => setSelectPrice(item)} style={{ width: "150px" }} className={`${IsSelected ? "bg-[--bgcolor] text-white" : "bg-gray-200 text-black"} text-center rounded-[15px] py-[30px] cursor-pointer duration-[0.3s]`}>
                                <h1 className='font-medium text-[17px]'>{formatPrice(item.price)}</h1>
                                <p className='text-[14px]'>{item.offer_title}% {t("Extra")}</p>
                            </SwiperSlide>
                        })}
                    </Swiper>
                </div>

                <div className="section_3">
                    <h1 className='font-medium text-[20px] mb-[10px]'>{t("Transaction History")}</h1>

                    {transactionlist.map((item, index) => {
                        return <div key={index} className="transaction_box shadow-sm border hover:shadow-md duration-[0.3s]">
                            <div className="flex items-center gap-[20px]">
                                <div className={`w-12 h-12 rounded-full flex items-center justify-center ${item.tra_type == "1" ? "bg-green-100" : "bg-red-100"}`}>
                                    {item.tra_type == "1"
                                        ? <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-6 h-6 text-green-600" aria-hidden="true">
                                            <path d="M16 7h6v6"></path><path d="m22 7-8.5 8.5-5-5L2 17"></path>
                                        </svg>
                                        : <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-6 h-6 text-red-600" aria-hidden="true"><path d="M16 17h6v-6"></path><path d="m22 17-8.5-8.5-5 5L2 7"></path></svg>}
                                </div>
                                <div className="">
                                    <h3 className="font-medium text-[17px] text-gray-900">{item.title}</h3>
                                    <p className="text-sm text-gray-600">{item.date}</p>
                                    {item.payment_name && <p className="text-xs text-gray-500 mt-1">via {item.payment_name}</p>}
                                </div>
                            </div>
                            <div className="text-end">
                                <h1 className={`text-[20px] font-medium ${item.tra_type == "1" ? "text-green-500" : "text-red-500"}`}>{item.tra_type == "1" ? "+" : "-"}{formatPrice(item.amount, 1)}</h1>
                            </div>
                        </div>
                    })}
                </div>

            </div>

            {isShowPay && <div onClick={() => setIsShowPay(false)} className="model items-end">
                <div onClick={(e) => e.stopPropagation()} className="payment_model">
                    <h1 className='font-medium text-[18px] text-gray-700 px-[20px] py-[10px]'>{t("Payment Information")}</h1>
                    <div className="border-y">
                        <div className="px-[20px] py-[5px]">
                            <div className="flex items-center justify-between gap-[10px] text-[15px]">
                                <h1>{t("Amount")}</h1>
                                <p>{formatPrice(selectprice?.price)}</p>
                            </div>
                            <div className="flex items-center justify-between gap-[10px] text-[15px]">
                                <h1>{t("Tax")}</h1>
                                <p>{formatPrice(texAmount)}</p>
                            </div>
                            <div className="flex items-center justify-between gap-[10px] text-[15px] font-medium">
                                <h1>{t("Payment")}</h1>
                                <p>{formatPrice(totalPay)}</p>
                            </div>
                        </div>
                    </div>
                    <div className="px-[20px] py-[10px]">
                        <h1 className='font-medium text-[18px] text-gray-700'>{t("Payment Method")}</h1>
                        <div className="h-[400px] scroll_container">
                            {paymentList?.map((item, index) => {
                                const IsSelected = item.name === selectpayment;
                                if (item.status === "1") {
                                    return <div key={index} onClick={() => handleSelectPayment(item)} className={`border-[1px] cursor-pointer ${IsSelected ? "border-[--bgcolor]" : "border-gray-300"} p-[10px] mt-[10px] rounded-[15px]`}>
                                        <div className="flex items-center gap-[10px]">
                                            <div className="flex items-center gap-[20px]">
                                                <div className="max-w-[60px] min-w-[60px] border-[1px] rounded-[12px] overflow-hidden border-gray-300">
                                                    <ImageLoad url={BaseUrl + item.image} CustomeStyle={"w-full h-full object-cover"} alt={`${item.name} Logo`} />
                                                </div>
                                                <div className="leading-6">
                                                    <h1 className='font-bold text-gray-700'>{item.name}</h1>
                                                    <p className='leading-4 font-medium text-[14px] text-gray-500 line-clamp-2'>{item.sub_title}</p>
                                                </div>
                                            </div>
                                            <div className="w-[20px]">
                                                <div className={`w-[18px] h-[18px] duration-[.5s] border-[2px] ${IsSelected ? "border-[--bgcolor]" : "border-gray-300"} rounded-full p-[2px]`}>
                                                    <div className={`w-full h-full duration-[.5s] rounded-full ${IsSelected ? "bg-[--bgcolor]" : "bg-transparent"}`}></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                            })}
                        </div>
                    </div>
                    <div className="w-full px-[15px] py-[10px]">
                        <button onClick={handleContinue} className='w-full h-[40px] text-white rounded-[50px] font-medium hover:shadow-lg duration-[.3s] bg-[--bgcolor]'>
                            {paymentloading ? <Btn_loader CustomeStyle={"bg-white"} /> : t("Continue")}
                        </button>
                    </div>
                </div>
            </div>}

            {apiloading === "Isbooking" && <div className="model items-center">
                <Btn_loader CustomeStyle={"bg-[--bgcolor]"} />
            </div>}

            {(selectpayment == "Razorpay" && istrue) && <Razorpay Amount={totalPay} attributes={attributes} />}
            {(selectpayment == "Paypal" && istrue) && <AllPayment Amount={totalPay} url={"payment/paypal-payment"} />}
            {(selectpayment == "Stripe" && istrue) && <AllPayment Amount={totalPay} url={"payment/strip-payment"} />}
            {(selectpayment == "PayStack" && istrue) && <AllPayment Amount={totalPay} url={"payment/paystack-payment"} />}
            {(selectpayment == "FlutterWave" && istrue) && <AllPayment Amount={totalPay} url={"payment/flutterwave-payment"} />}
            {(selectpayment == "SenangPay" && istrue) && <AllPayment Amount={totalPay} url={"payment/senangpay-payment"} />}
            {(selectpayment == "Payfast" && istrue) && <AllPayment Amount={totalPay} url={"payment/payfast-payment"} />}
            {(selectpayment == "Midtrans" && istrue) && <AllPayment Amount={totalPay} url={"payment/midtrans-payment"} />}

            <PageLoading loading={loading} />

        </div>
    )
}

export default Wallet;